// Centralized query key factory. Every query hook in `queries/` sources its
// key from here, and every mutation hook in `mutations/` invalidates via the
// same functions, so a resource's cache shape is defined in exactly one
// place. Keys are arrays ordered general -> specific so partial keys (e.g.
// `queryKeys.stores.all`) can invalidate every query under them at once.
export const queryKeys = {
  stores: {
    all: ["stores"],
    lists: () => [...queryKeys.stores.all, "list"],
    byCategory: (category) => [...queryKeys.stores.lists(), { category }],
    detail: (storeId) => [...queryKeys.stores.all, "detail", storeId],
  },
  catalog: {
    all: ["catalog"],
    byStore: (storeId) => [...queryKeys.catalog.all, storeId],
    liquor: (storeId, type, subType) => [
      ...queryKeys.catalog.all,
      storeId,
      "liquor",
      type,
      subType,
    ],
  },
  ratings: {
    all: ["ratings"],
    stats: (storeId) => [...queryKeys.ratings.all, storeId, "stats"],
    user: (storeId, uid) => [...queryKeys.ratings.all, storeId, "user", uid],
  },
  products: {
    all: ["products"],
    detail: (productId) => [...queryKeys.products.all, productId],
    options: (productId) => [...queryKeys.products.all, productId, "options"],
    optionList: (productId, optionId) => [
      ...queryKeys.products.all,
      productId,
      "options",
      optionId,
    ],
    optionItem: (productId, optionId, itemId) => [
      ...queryKeys.products.all,
      productId,
      "options",
      optionId,
      itemId,
    ],
  },
  merchant: {
    all: ["merchant"],
    ordersCount: (storeId, period) => [...queryKeys.merchant.all, storeId, "ordersCount", period],
    ordersAverage: (storeId, period) => [...queryKeys.merchant.all, storeId, "ordersAverage", period],
    revenue: (storeId, period) => [...queryKeys.merchant.all, storeId, "revenue", period],
    revenuePeriod: (storeId, period) => [...queryKeys.merchant.all, storeId, "revenuePeriod", period],
    statusAverage: (storeId, period) => [...queryKeys.merchant.all, storeId, "statusAverage", period],
    activeOrders: (storeId) => [...queryKeys.merchant.all, storeId, "activeOrders"],
    orderHistory: (storeId, filter) => [...queryKeys.merchant.all, storeId, "orderHistory", filter],
  },
  ops: {
    all: ["ops"],
    placedOrders: () => [...queryKeys.ops.all, "placedOrders"],
    activeOrders: (rid) => [...queryKeys.ops.all, "activeOrders", rid],
  },
  account: {
    all: ["account"],
    orderById: (id) => [...queryKeys.account.all, "order", id],
    activeDelivery: (rid, id) => [...queryKeys.account.all, "activeDelivery", rid, id],
    deliveredOrders: (rid) => [...queryKeys.account.all, "deliveredOrders", rid],
    allOrders: () => [...queryKeys.account.all, "allOrders"],
    ordersHistory: (uid) => [...queryKeys.account.all, "ordersHistory", uid],
    placedOrders: () => [...queryKeys.account.all, "placedOrders"],
    activeOrders: (rid) => [...queryKeys.account.all, "activeOrders", rid],
    activeOrder: (rid, oid) => [...queryKeys.account.all, "activeOrder", rid, oid],
  },
  payments: {
    all: ["payments"],
    status: (invoiceId) => [...queryKeys.payments.all, "status", invoiceId],
  },
  serviceStatus: {
    all: ["serviceStatus"],
  },
};
